import * as React from "react"
import { SVGProps } from "react"

type AddNewRequestProps = SVGProps<SVGSVGElement> & {
    circleColor?: string;
    iconColor?: string;
};

const RenewRequestIcon: React.FC<AddNewRequestProps> = (props) => {

    const { height = 32, width = 32, 
        circleColor = 'white', iconColor = 'black', ...rest } = props;


    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="renew request">
                <rect width={32} height={32} fill="white" />
                <g id="page">
                    <g id="back-page">
                        <path
                            d="M24 2H9C8.44772 2 8 2.44772 8 3V5H21C21.5523 5 22 5.44772 22 6V25.9659C22 25.9847 22.0153 26 22.0341 26H24C24.5523 26 25 25.5523 25 25V3C25 2.44772 24.5523 2 24 2Z"
                            fill="#D9D9D9"
                        />
                        <path
                            d="M8 5V3C8 2.44772 8.44772 2 9 2H24C24.5523 2 25 2.44772 25 3V25C25 25.5523 24.5523 26 24 26H22.0341C22.0153 26 22 25.9847 22 25.9659V6C22 5.44772 21.5523 5 21 5H8Z"
                            stroke="black"
                            strokeWidth={0.5}
                        />
                    </g>
                    <path
                        id="front-page"
                        d="M6 5H21C21.5523 5 22 5.44772 22 6V28C22 28.5523 21.5523 29 21 29H10.3837C10.1367 29 9.8984 28.9086 9.71477 28.7433L5.33104 24.7979C5.12032 24.6083 5 24.3381 5 24.0546V6C5 5.44772 5.44772 5 6 5Z"
                        stroke="black"
                        strokeWidth={0.5}
                    />
                    <path
                        id="folder-page"
                        d="M5 24H9C9.55228 24 10 24.4477 10 25V29"
                        stroke="black"
                        strokeWidth={0.5}
                    />
                </g>
                <g id="circle">
                    <circle
                        id="inner-circle"
                        cx={20.5}
                        cy={23.5}
                        r={7.25}
                        fill={circleColor || "#D9D9D9"}
                        stroke={iconColor || "black"}
                        strokeWidth={0.5}
                    />
                    <path
                        id="icon"
                        d="M24.8329 23.5532L22.8182 22.2037M24.8672 23.5532L26 21.7539M24.836 23.5532C24.836 17.4095 16 17.5555 16 23.5532C16 28.8751 23.2727 29.2685 24.7712 25.3525"
                        stroke={iconColor || "black"}
                        strokeLinecap="round"
                    />
                </g>
                <g id="lines">
                    <g id="line-8" filter="url(#filter0_d_15_677)">
                        <line
                            x1={6.5}
                            y1={21.5}
                            x2={11.5}
                            y2={21.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-7" filter="url(#filter1_d_15_677)">
                        <line
                            x1={6.5}
                            y1={19.5}
                            x2={12.5}
                            y2={19.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-6" filter="url(#filter2_d_15_677)">
                        <line
                            x1={6.5}
                            y1={17.5}
                            x2={13.5}
                            y2={17.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-5" filter="url(#filter3_d_15_677)">
                        <line
                            x1={7.86365}
                            y1={15.5}
                            x2={17.7727}
                            y2={15.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-4" filter="url(#filter4_d_15_677)">
                        <line
                            x1={12.5}
                            y1={13.5}
                            x2={20.5}
                            y2={13.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-3" filter="url(#filter5_d_15_677)">
                        <line
                            x1={14.5}
                            y1={11.5}
                            x2={20.5}
                            y2={11.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-2" filter="url(#filter6_d_15_677)">
                        <line
                            x1={15.5}
                            y1={9.5}
                            x2={20.5}
                            y2={9.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="line-1" filter="url(#filter7_d_15_677)">
                        <line
                            x1={16.5}
                            y1={7.5}
                            x2={20.5}
                            y2={7.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                </g>
                <g id="pencil-icon">
                    <path
                        id="Vector 27"
                        d="M8.18689 12.3411L13.1745 7.35355C13.3697 7.15829 13.6863 7.15829 13.8816 7.35355L14.2593 7.73129C14.4546 7.92655 14.4546 8.24313 14.2593 8.43839L9.27173 13.426"
                        stroke="black"
                        strokeWidth={0.5}
                        strokeLinecap="round"
                    />
                    <path
                        id="Vector 28"
                        d="M8.18692 12.3411L7.54242 14.0705L9.27176 13.426"
                        stroke="black"
                        strokeWidth={0.5}
                        strokeLinecap="round"
                    />
                    <path
                        id="Vector 29"
                        d="M12.3411 8.18692L13.426 9.27176"
                        stroke="black"
                        strokeWidth={0.5}
                        strokeLinecap="round"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_15_677"
                    x={2}
                    y={21}
                    width={14}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_15_677"
                    x={2}
                    y={19}
                    width={15}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_d_15_677"
                    x={2}
                    y={17}
                    width={16}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter3_d_15_677"
                    x={3.36365}
                    y={15}
                    width={18.9091}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter4_d_15_677"
                    x={8}
                    y={13}
                    width={17}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter5_d_15_677"
                    x={10}
                    y={11}
                    width={15}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter6_d_15_677"
                    x={11}
                    y={9}
                    width={14}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter7_d_15_677"
                    x={12}
                    y={7}
                    width={13}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_15_677"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_15_677"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
export default RenewRequestIcon;